// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UB7M","colBig":"styles_colBig__27abV","colSmall":"styles_colSmall__3J7-k"};